import { createAppKit } from '@reown/appkit/react';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { mainnet } from '@reown/appkit/networks';
import { QueryClient } from '@tanstack/react-query';

// Get project ID from https://dashboard.reown.com (or cloud.walletconnect.com)
// Set PUBLIC_WALLETCONNECT_PROJECT_ID in .env for production
const projectId =
  (typeof import.meta !== 'undefined' &&
    (import.meta as { env?: Record<string, string> }).env
      ?.PUBLIC_WALLETCONNECT_PROJECT_ID) ||
  'b56e18d47c72ab683b10814fe9495694'; // public demo ID for localhost

const metadata = {
  name: 'Petso',
  description: 'Petso – Verify your wallet for airdrops and ICO claims',
  url:
    typeof window !== 'undefined' ? window.location.origin : 'https://petso.io',
  icons: ['https://petso.io/icon.png'],
};

const networks = [mainnet] as const;

const wagmiAdapter = new WagmiAdapter({
  networks: [...networks],
  projectId,
  ssr: true,
});

createAppKit({
  adapters: [wagmiAdapter],
  networks: [mainnet],
  projectId,
  metadata,
  features: {
    analytics: false,
    email: false,
    socials: [],
    connectMethodsOrder: ['wallet'],
  },
  allWallets: 'HIDE',
  // Only show MetaMask and WalletConnect. Get IDs from https://walletguide.walletconnect.network/
  includeWalletIds: [
    'c57ca95b46e4fb0543080ce7017b9e2f1a6d2d6c2e2f1a6d2d6c2e2f1a6d2d6c2', // WalletConnect
    'fd20dc0fb91b414890d2aaaf4e70d70d2aaaf4e70d70d2aaaf4e70d70d2aaaf4', // MetaMask
  ],
  featuredWalletIds: [
    'c57ca95b46e4fb0543080ce7017b9e2f1a6d2d6c2e2f1a6d2d6c2e2f1a6d2d6c2',
    'fd20dc0fb91b414890d2aaaf4e70d70d2aaaf4e70d70d2aaaf4e70d70d2aaaf4',
  ],
});

export const wagmiConfig = wagmiAdapter.wagmiConfig;
export const queryClient = new QueryClient();
